import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";



import training1 from "../../../assets/global3.png";

import ApiService from "../../../nhrc_apis/ApiService";

const {EventAPI}=ApiService;



function    Hrevents() {
    
const navigate=useNavigate();
const [events,setEvents]=useState([]);
const [loading,setLoading]=useState(false);


useEffect(()=>{
    fetchEvents();

},[]);

const fetchEvents=async()=>{
    try {

        setLoading(true);

        const resposnse=await EventAPI.getHrEvents();
        console.log("HR Events response: ",
        resposnse
    );
        console.log(
            "hr events data:",
            resposnse?.data
        );

        let eventsList=[];

        if(Array.isArray(resposnse?.data)){
            eventsList=resposnse.data;

        }else if(Array.isArray(resposnse ?.data?.data)){
            eventsList=resposnse.data.data;
        }
        else if(Array.isArray(resposnse?.data?.events)){
            eventsList=resposnse.data.events;
        }
        setEvents(eventsList);

    } catch (error) {
        console.log(
            "get events error:",
            error
        );
        
    }
    finally{
            setLoading(false)
        }
};

   
    return (
    <>
      <section className="training-section">

        <div className="text-center mb-4">
          <h3 className="training-title mt-5">
            Event Program
          </h3>
        </div>

        {loading ? (

          <div className="text-center mt-5">
            <div className="spinner-border text-primary" />
          </div>

        ) : (

          <div className="training-grid">

            {events.length > 0 ? (

              events.map((item, index) => (

                <div
                  className="training-card"
                  key={
                    item.id || index
                  }
                >

                  {/* Left Content */}

                  <div className="training-info">

                    <p>
                      <strong>
                        Event Title :
                      </strong>{" "}
                      {item.eventTitle ||
                        item.title ||
                        "N/A"}
                    </p>

                    <p>
                      <strong>
                        Organizer Name :
                      </strong>{" "}
                      {item.organizer_name ||
                        item.organizer ||
                        "N/A"}
                    </p>

                    <p>
                      <strong>
                        Speaker Name :
                      </strong>{" "}
                      {item.speaker_name ||
                        item.speaker ||
                        "N/A"}
                    </p>

                    <p>
                      <strong>
                        Event Mode :
                      </strong>{" "}
                      {item.event_mode ||
                        item.mode ||
                        "N/A"}
                    </p>

                    <p>
                      <strong>
                        Event Schedule :
                      </strong>{" "}
                      {item.start_date ||
                        item.eventSchedule ||
                        "N/A"}
                    </p>

                    <p>
                      <strong>
                        Time :
                      </strong>{" "}
                      {item.time ||
                        item.start_time ||
                        "N/A"}
                    </p>

                    <p>
                      <strong>
                        Location :
                      </strong>{" "}
                      {item.location ||
                        item.venue ||
                        "N/A"}
                    </p>

                    <button
                      className="training-btn"
                      onClick={() =>
                        navigate(
                          "/hrdashboard/EventRegistration",
                          {
                            state: {
                              event: item,
                            },
                          }
                        )
                      }
                    >
                      REGISTER NOW
                    </button>

                  </div>

                  {/* Right Image */}

                  <div className="training-img">

                    <img
                      src={
                        item.image ||
                        item.eventImage ||
                        training1
                      }
                      className="img-fluid"
                      alt={
                        item.title ||
                        "Event"
                      }
                    />

                  </div>

                </div>
              ))

            ) : (

              <div className="text-center py-5">
                <h5>
                  No Events Available
                </h5>
              </div>

            )}

          </div>

        )}

      </section>
    </>
  );
}

export default Hrevents;